import { ThunkAction } from 'redux-thunk';

import { CategoryMapping, GetInstrumentsOptions } from 'types/drupal/InstrumentNode';
import { IRootState } from '../root_reducer';

import { InstrumentsApi } from 'providers/api';

import Log from 'providers/log';

// ACTION declaration here
export const FETCH_YEAR_CATEGORY_FILTERS = 'gruhn-guitars-modern/inventory_filter_data/FETCH_YEAR_CATEGORY_FILTERS';
export const FETCH_MANUFACTURER_MODEL_FILTERS = 'gruhn-guitars-modern/inventory_filter_data/FETCH_MANUFACTURER_MODEL_FILTERS';
export const SET_INVENTORY_FILTER_DATA = 'gruhn-guitars-modern/inventory_filter_data/SET_INVENTORY_FILTER_DATA';
export const TOGGLE_FILTER_VIEW = 'gruhn-guitars-modern/inventory_filter_data/TOGGLE_FILTER_VIEW';

export interface InventoryFilterDataAction {
    type: string;
    new_state: InventoryFilterDataState;
    get_options?: Partial<GetInstrumentsOptions>;
    viewFilters: boolean;
}

export interface InventoryFilterDataState {
    categories: CategoryMapping[];
    manufacturers: string[];
    models: string[];
    viewFilters: boolean;
    years: string[];
}

const initialState: InventoryFilterDataState = {
    categories: [],
    manufacturers: [],
    models: [],
    viewFilters: false,
    years: []
};

export default function (state: InventoryFilterDataState = initialState, action: InventoryFilterDataAction): InventoryFilterDataState {
    switch (action.type) {
        case TOGGLE_FILTER_VIEW:
            return { ...state, viewFilters: action.viewFilters };
        case SET_INVENTORY_FILTER_DATA:
            return { ...state, ...action.new_state };
        default:
            return state;
    }
}

export const getYearCategoryFilters = (get_options?: Partial<GetInstrumentsOptions>): ThunkAction<void, IRootState, null, any> => (dispatch) => {
    dispatch({ type: FETCH_YEAR_CATEGORY_FILTERS });

    const promiseOrganizer: { promise: Promise<any>, objectKey: string }[] = [
        { promise: InstrumentsApi.getCategories(), objectKey: 'categories' },
        { promise: InstrumentsApi.getYears(), objectKey: 'years' }
    ];

    Promise.all(promiseOrganizer.map(v => v.promise)).then((results) => {
        dispatch({
            new_state: {
                categories: results[0], // TODO: find a way to remove these hard coded indexes
                years: results[1]
            },
            type: SET_INVENTORY_FILTER_DATA
        });
    }).catch(reason => Log.error(reason));
};

export const getManufacturerModelFilters = (get_options?: Partial<GetInstrumentsOptions>): ThunkAction<void, IRootState, null, any> => (dispatch) => {
    dispatch({ type: FETCH_MANUFACTURER_MODEL_FILTERS });

    const promiseOrganizer: { promise: Promise<any>, objectKey: string }[] = [
        { promise: InstrumentsApi.getManufacturers(get_options), objectKey: 'manufacturers' },
        { promise: InstrumentsApi.getModels(get_options), objectKey: 'models' }
    ];

    Promise.all(promiseOrganizer.map(v => v.promise)).then((results) => {
        dispatch({
            new_state: {
                manufacturers: results[0],
                models: results[1]
            },
            type: SET_INVENTORY_FILTER_DATA
        });
    }).catch(reason => Log.error(reason));
};

/**
 * toggle filter view
 */
export const toggleFilterView = (viewFilters: boolean) => (dispatch: any) => {
    dispatch({
        type: TOGGLE_FILTER_VIEW,
        viewFilters
    });
};



// WEBPACK FOOTER //
// ./src/redux/modules/inventory_filter_data.ts